export default __webpack_public_path__ + "static/media/watches12.cafa1b5e.jfif";